export default __webpack_public_path__ + "static/media/add.words.dbd4bbbb.svg";